import React from "react";
import { Chip } from "@mui/material";
import { STATUS_CONFIG } from "../../constants/strings";

interface Props {
  status: string;
}

const StatusChip: React.FC<Props> = ({ status }) => {
  const normalized = status?.toLowerCase();

  // 🔥 find matching config
  const config =
    Object.values(STATUS_CONFIG).find(
      (item) => item.value === normalized
    ) || {
      label: status,
      bg: "var(--border-color)",
      color: "var(--text-primary)",
    };

  return (
    <Chip
      label={config.label}
      sx={{
        backgroundColor: config.bg,
        color: config.color,
        fontWeight: 500,
        borderRadius: "8px",
        textTransform: "capitalize",
      }}
    />
  );
};

export default StatusChip;